import {
  SET_FEEDBACK,
  RESET_FEEDBACK,
  SET_CUSTOM_INSTRUCTIONS,
  SET_AUTO_PODCAST,
  CLEAR_CUSTOM_INSTRUCTIONS,
  SET_STUDY_MODE,
  SET_EXAM_DATE,
  SET_STUDY_DATE_WARNING,
  SET_SELECTED_MATERIA,
  SET_MATERIA_WARNING
} from '../../actions/types';

// Handler per SET_FEEDBACK
export const handleSetFeedback = (state, payload) => {
  // Adattamento per supportare il formato usato dall'action creator
  const type = payload.feedbackType;
  const questionId = payload.index;
  const feedback = payload.feedback;
  
  // Validazione del payload
  if (!type || questionId === undefined || feedback === undefined) {
    console.error('Payload SET_FEEDBACK incompleto:', payload);
    return state;
  }
  
  // Aggiornamento dello stato per il tipo specificato (domande o flashcards)
  const currentFeedbacks = state.feedbacks || { questions: new Map(), flashcards: new Map() };
  
  if (type === 'question' || type === 'questions') {
    // Creiamo una nuova Map per evitare mutazioni dello stato
    const updatedQuestions = new Map(currentFeedbacks.questions);
    updatedQuestions.set(questionId, feedback);
    
    return {
      ...state,
      feedbacks: {
        ...currentFeedbacks,
        questions: updatedQuestions
      }
    };
  } else if (type === 'flashcard' || type === 'flashcards') {
    // Creiamo una nuova Map per evitare mutazioni dello stato
    const updatedFlashcards = new Map(currentFeedbacks.flashcards);
    updatedFlashcards.set(questionId, feedback);
    
    return {
      ...state,
      feedbacks: {
        ...currentFeedbacks,
        flashcards: updatedFlashcards
      }
    };
  }
  
  // Se il tipo non è valido, restituisci lo stato invariato
  console.error('Tipo di feedback non valido:', type);
  return state;
};

// Handler per RESET_FEEDBACK
export const handleResetFeedback = (state) => {
  return {
    ...state,
    feedbacks: {
      questions: new Map(),
      flashcards: new Map()
    }
  };
};

// Handler per SET_CUSTOM_INSTRUCTIONS
export const handleSetCustomInstructions = (state, payload) => {
  if (typeof payload !== 'string') {
    console.error('Payload SET_CUSTOM_INSTRUCTIONS non valido:', payload);
    return state;
  }
  
  return {
    ...state,
    customInstructions: payload
  };
};

// Handler per CLEAR_CUSTOM_INSTRUCTIONS
export const handleClearCustomInstructions = (state) => {
  return {
    ...state,
    customInstructions: ''
  };
};

// Handler per SET_AUTO_PODCAST — la spunta "genera anche il podcast" nel
// modulo di caricamento. Booleano secco: qualunque altra cosa arrivi, si
// normalizza, perche' da questo valore dipende una spesa.
export const handleSetAutoPodcast = (state, payload) => {
  return {
    ...state,
    autoPodcast: payload === true
  };
};

// Handler per SET_STUDY_MODE
export const handleSetStudyMode = (state, payload) => {
  // Consenti 'study', 'review' o null (per reset)
  if (payload !== null && payload !== 'study' && payload !== 'review') {
    console.error('Payload SET_STUDY_MODE non valido:', payload);
    return state;
  }
  
  return {
    ...state,
    studyMode: payload
  };
};

// Handler per SET_EXAM_DATE
export const handleSetExamDate = (state, payload) => {
  if (typeof payload !== 'string') {
    console.error('Payload SET_EXAM_DATE non valido:', payload);
    return state;
  }
  
  return {
    ...state,
    examDate: payload
  };
};

// Handler per SET_STUDY_DATE_WARNING
export const handleSetStudyDateWarning = (state, payload) => {
  return {
    ...state,
    studyDateWarning: Boolean(payload)
  };
};

// Handler per SET_SELECTED_MATERIA
export const handleSetSelectedMateria = (state, payload) => {
  return {
    ...state,
    selectedMateria: payload || '',
    showMateriaWarning: false
  };
};

// Handler per SET_MATERIA_WARNING
export const handleSetMateriaWarning = (state, payload) => {
  return {
    ...state,
    showMateriaWarning: Boolean(payload)
  };
};

// Handler per SET_EXCLUDED_DAYS
export const handleSetExcludedDays = (state, payload) => {
  if (!Array.isArray(payload) || !payload.every(d => Number.isInteger(d) && d >= 0 && d <= 6)) {
    console.error('Payload SET_EXCLUDED_DAYS non valido:', payload);
    return state;
  }
  return {
    ...state,
    excludedDays: payload
  };
};

// Reducer per la gestione dei feedback
const feedbackReducer = (state, action) => {
  switch (action.type) {
    case SET_FEEDBACK:
      return handleSetFeedback(state, action.payload);
    case RESET_FEEDBACK:
      return handleResetFeedback(state);
    case SET_CUSTOM_INSTRUCTIONS:
      return handleSetCustomInstructions(state, action.payload);
    case CLEAR_CUSTOM_INSTRUCTIONS:
      return handleClearCustomInstructions(state);
    case SET_AUTO_PODCAST:
      return handleSetAutoPodcast(state, action.payload);
    case SET_STUDY_MODE:
      return handleSetStudyMode(state, action.payload);
    case SET_EXAM_DATE:
      return handleSetExamDate(state, action.payload);
    case SET_STUDY_DATE_WARNING:
      return handleSetStudyDateWarning(state, action.payload);
    case 'SET_EXCLUDED_DAYS':
      return handleSetExcludedDays(state, action.payload);
    case SET_SELECTED_MATERIA:
      return handleSetSelectedMateria(state, action.payload);
    case SET_MATERIA_WARNING:
      return handleSetMateriaWarning(state, action.payload);
    default:
      return null; // Indica che questa azione non è gestita da questo reducer
  }
};

export default feedbackReducer; 